import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import FormEditDerivacion from "./formEditDerivacion";

const editDerivacionFormModal = ({
  toggle,
  isOpen,
  info,
  handleEditDerivacion,
  vacantes,
  cobertura,
  notaDePedidoId,
  setReloadCandidatos,
  fechaAbierta,
  idsCandidatosDerivados,
  servicio,
  uploadOrPatchFilesCV,
  candidatosEnLaDerivacion,
}) => {
  return (
    <div>
      <Modal isOpen={isOpen} centered style={{ fontFamily: "Nunito" }}>
        <ModalHeader toggle={toggle} style={{ borderBottom: "none", background: " #f8f8f8" }}>
          Editar derivación
        </ModalHeader>
        <ModalBody style={{ background: " #f8f8f8" }}>
          <FormEditDerivacion
            toggle={toggle}
            info={info}
            handleEditDerivacion={handleEditDerivacion}
            vacantes={vacantes}
            cobertura={cobertura}
            notaDePedidoId={notaDePedidoId}
            setReloadCandidatos={setReloadCandidatos}
            fechaAbierta={fechaAbierta}
            idsCandidatosDerivados={idsCandidatosDerivados}
            servicio={servicio}
            uploadOrPatchFilesCV={uploadOrPatchFilesCV}
            candidatosEnLaDerivacion={candidatosEnLaDerivacion}
          />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default editDerivacionFormModal;
